import { createAction } from '@reduxjs/toolkit'

export const setPrice = createAction<{ tokenId: string; price: number }>('tokenPrice/setPrice')
export const setLoading = createAction<{ tokenId: string; loading: boolean }>('tokenPrice/setLoading')
